/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_LabelInputs */

const en_home_faq_label = /** @type {(inputs: Home_Faq_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common Questions`)
};

const fr_home_faq_label = /** @type {(inputs: Home_Faq_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions fréquentes`)
};

/**
* | output |
* | --- |
* | "Common Questions" |
*
* @param {Home_Faq_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_label = /** @type {((inputs?: Home_Faq_LabelInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_LabelInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_label(inputs)
	return fr_home_faq_label(inputs)
});